const bhAction = action => `BRAIN_HEALTH/${action}`;

// Spaces
const GET_SPACES = bhAction('GET_SPACES');
const GET_SPACES_SUCCESS = bhAction('GET_SPACES_SUCCESS');
const GET_SPACES_FAILURE = bhAction('GET_SPACES_FAILURE');

const CREATE_SPACE = bhAction('CREATE_SPACE');
const CREATE_SPACE_SUCCESS = bhAction('CREATE_SPACE_SUCCESS');
const CREATE_SPACE_FAILURE = bhAction('CREATE_SPACE_FAILURE');

const UPDATE_SPACE = bhAction('UPDATE_SPACE');
const UPDATE_SPACE_SUCCESS = bhAction('UPDATE_SPACE_SUCCESS');
const UPDATE_SPACE_FAILURE = bhAction('UPDATE_SPACE_FAILURE');

const DELETE_SPACE = bhAction('DELETE_SPACE');
const DELETE_SPACE_SUCCESS = bhAction('DELETE_SPACE_SUCCESS');
const DELETE_SPACE_FAILURE = bhAction('DELETE_SPACE_FAILURE');

// Assessment (client-side compute + save)
const RUN_ASSESSMENT = bhAction('RUN_ASSESSMENT');
const RUN_ASSESSMENT_SUCCESS = bhAction('RUN_ASSESSMENT_SUCCESS');
const SAVE_ASSESSMENT = bhAction('SAVE_ASSESSMENT');
const SAVE_ASSESSMENT_SUCCESS = bhAction('SAVE_ASSESSMENT_SUCCESS');
const SAVE_ASSESSMENT_FAILURE = bhAction('SAVE_ASSESSMENT_FAILURE');

const GET_ASSESSMENTS = bhAction('GET_ASSESSMENTS');
const GET_ASSESSMENTS_SUCCESS = bhAction('GET_ASSESSMENTS_SUCCESS');
const GET_ASSESSMENTS_FAILURE = bhAction('GET_ASSESSMENTS_FAILURE');

// BHPS features
const GET_BHPS_FEATURES = bhAction('GET_BHPS_FEATURES');
const GET_BHPS_FEATURES_SUCCESS = bhAction('GET_BHPS_FEATURES_SUCCESS');
const GET_BHPS_FEATURES_FAILURE = bhAction('GET_BHPS_FEATURES_FAILURE');

const UPDATE_BHPS_FEATURES = bhAction('UPDATE_BHPS_FEATURES');
const UPDATE_BHPS_FEATURES_SUCCESS = bhAction('UPDATE_BHPS_FEATURES_SUCCESS');
const UPDATE_BHPS_FEATURES_FAILURE = bhAction('UPDATE_BHPS_FEATURES_FAILURE');

// Population
const GET_POPULATION = bhAction('GET_POPULATION');
const GET_POPULATION_SUCCESS = bhAction('GET_POPULATION_SUCCESS');
const GET_POPULATION_FAILURE = bhAction('GET_POPULATION_FAILURE');

const SAVE_POPULATION = bhAction('SAVE_POPULATION');
const SAVE_POPULATION_SUCCESS = bhAction('SAVE_POPULATION_SUCCESS');
const SAVE_POPULATION_FAILURE = bhAction('SAVE_POPULATION_FAILURE');

const DELETE_POPULATION = bhAction('DELETE_POPULATION');
const DELETE_POPULATION_SUCCESS = bhAction('DELETE_POPULATION_SUCCESS');
const DELETE_POPULATION_FAILURE = bhAction('DELETE_POPULATION_FAILURE');

// Financial ROI (client-side compute)
const COMPUTE_STAFF_ROI = bhAction('COMPUTE_STAFF_ROI');
const COMPUTE_RESIDENT_ROI = bhAction('COMPUTE_RESIDENT_ROI');
const SET_STAFF_ROI = bhAction('SET_STAFF_ROI');
const SET_RESIDENT_ROI = bhAction('SET_RESIDENT_ROI');

export default {
  GET_SPACES, GET_SPACES_SUCCESS, GET_SPACES_FAILURE,
  CREATE_SPACE, CREATE_SPACE_SUCCESS, CREATE_SPACE_FAILURE,
  UPDATE_SPACE, UPDATE_SPACE_SUCCESS, UPDATE_SPACE_FAILURE,
  DELETE_SPACE, DELETE_SPACE_SUCCESS, DELETE_SPACE_FAILURE,
  RUN_ASSESSMENT, RUN_ASSESSMENT_SUCCESS,
  SAVE_ASSESSMENT, SAVE_ASSESSMENT_SUCCESS, SAVE_ASSESSMENT_FAILURE,
  GET_ASSESSMENTS, GET_ASSESSMENTS_SUCCESS, GET_ASSESSMENTS_FAILURE,
  GET_BHPS_FEATURES, GET_BHPS_FEATURES_SUCCESS, GET_BHPS_FEATURES_FAILURE,
  UPDATE_BHPS_FEATURES, UPDATE_BHPS_FEATURES_SUCCESS, UPDATE_BHPS_FEATURES_FAILURE,
  GET_POPULATION, GET_POPULATION_SUCCESS, GET_POPULATION_FAILURE,
  SAVE_POPULATION, SAVE_POPULATION_SUCCESS, SAVE_POPULATION_FAILURE,
  DELETE_POPULATION, DELETE_POPULATION_SUCCESS, DELETE_POPULATION_FAILURE,
  COMPUTE_STAFF_ROI, COMPUTE_RESIDENT_ROI, SET_STAFF_ROI, SET_RESIDENT_ROI,
};
